The party that owns the position opening.

This may be different from the hiring organization if the position opening was created by a recruitment agency outside of the SEEK API.
